// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YY4eU","label":"styles_label__tsbt-"};